import Menu from './Compartido/Menu.jsx';
import TextosPoliticaPrivacidad from './PoliticaPrivacidad/TextosPoliticaPrivacidad.jsx';
import Footer from './Compartido/Footer.jsx';

const PoliticaPrivacidad = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosPoliticaPrivacidad
                politicaprivacidad={props.textopoliticaprivacidad}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default PoliticaPrivacidad;
